import React, { useState, useEffect, useMemo } from "react";
import Layout from "../../../components/Layout";
import {
  Cell,
  CellItem,
  CellItemLink,
  CellItemWithImage,
  CellItemSwitch,
} from "../../../components/_widgets/WidgetsSingleCell";
import {
  List,
  ListHeader,
  ListHeaderItem,
  ListHeaderItemDropdown,
  ListBody,
  ListBodyCell,
  ListBodyItem,
  ListBodyItemStatus,
  ListBodyItemImage,
} from "../../../components/_widgets/WidgetsList";
import { ListComments, ListCommentsItem } from "../../../components/_widgets/WidgetsListComments";
import WidgetTitle from "../../../components/_widgets/WidgetTitle";
import Carrossel from "../../../components/Carrosel";
import filledStar from "../../../assets/img/start-filled-rounded.svg";
import outlineStar from "../../../assets/img/star-outline-rounded.svg";
import facebookIcon from "../../../assets/img/facebook-icon.png";
import linkedinIcon from "../../../assets/img/linkedin-icon.png";
import youtubeIcon from "../../../assets/img/youtube-icon.png";
import whatsappIcon from "../../../assets/img/whatsapp-icon.png";
import instagranIcon from "../../../assets/img/instagran-icon.png";
import userDefaultImage from "../../../assets/img/user_img-default.png";
import ReactStars from "react-rating-stars-component";
import Maps from "../../../components/Maps";
import DonutChart from "../../../components/_charts/DonutChart";
import {
  formatDate,
  getClientAll,
  getProductAll,
  getClientReservationsAllByEstablishment,
  getCategories,
  AllEstablishment,
  getCategoriesChildren,
} from "../../../config/utils";
import api from "../../../config/api";
import SearchInput from "../../../components/inputs/SearchInput";
import EmptyListContent from "../../_user/Product/components/List/EmptyListContent";
import EmptyContentLittle from "../../../components/EmptyContent/EmptyContentLittle";
require("dotenv").config();

function SingleStore(props) {
  const [establishment, setEstablishment] = useState({});
  const [clientReservation, setClientReservation] = useState([]);
  const [comments, setComments] = useState([]);
  const [products, setProducts] = useState([]);
  const [storeRate, setStoreRate] = useState(0);

  // Pagination
  const [qtLimitItem, setQtLimitItem] = useState(10);
  const [pageItemsListProduct, setPageItemsListProduct] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [totalClientReservation, setTotalClientReservation] = useState(0);
  const [qtLimitItemClient, setQtLimitItemClient] = useState(6);
  const [pageItemsList, setPageItemsList] = useState(1);
  //-------------------------
  const [totalComments, setTotalComments] = useState(0);
  const [qtLimitItemComments, setQtLimitItemComments] = useState(6);
  const [pageComment, setPageComment] = useState(1);

  // Filter
  const [productsAll, setProductsAll] = useState([]);
  const [establishmentAll, setEstablishmentAll] = useState([]);
  const [categoryAll, setCategoryAll] = useState([]);
  const [categoryChildrenAll, setCategoryChildrenAll] = useState([]);
  //const [selectedProduct, setSelectedProduct] = useState("");
  const [selectedEstablishment, setSelectedEstablishment] = useState("");
  const [selectedCategoryChildren, setSelectedCategoryChildren] = useState("");
  const [nameFilter, setNameFilter] = useState("");
  const [allClient, setAllClient] = useState([]);
  const [allProduct, setAllProduct] = useState([]);
  const [filterDropdownName, setFilterDropdownName] = useState("");
  const [filterDropdownProductName, setFilterDropdownProductName] = useState("");
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [nameFilterClient, setNameFilterClient] = useState("");
  const [nameFilterProduct, setNameFilterProduct] = useState("");
  const [reservasChart, setReservasChart] = useState(0);
  const [pendentesChart, setPendentesChart] = useState(0);
  const [vendasChart, setVendasChart] = useState(0);
  const [canceladasChart, setCanceladasChart] = useState(0);
  const [ratingStars, setRatingStars] = useState("");
  const loadingEstablishment = useMemo(() => establishment.rate === undefined, [establishment]);

  const getProduct = async (
    page,
    limit,
    selectedProduct,
    selectedEstablishment,
    selectedCategoryChildren,
    nameFilter
  ) => {
    let response = await api.get(
      `/product?paginate=true&page=${page}&limit=${limit}&productFilter=${selectedProduct}&establishment=${props.match.params.id}&category=${selectedCategoryChildren}&name=${nameFilter}`
    );

    setProducts(response.data.docs);
    setTotalItems(response.data.total);
  };

  useEffect(() => {
    getEstablishment();
    getClientReservations(
      pageItemsList,
      qtLimitItemClient,
      selectedClient,
      selectedStatus,
      nameFilterClient,
      selectedProduct
    );
    getComments(pageComment, qtLimitItemComments);
    getALLComments();
    getClient();
    getProducts();
    getAllClientReservations(props.match.params.id);
    getProduct(
      pageItemsListProduct,
      qtLimitItem,
      selectedProduct,
      selectedEstablishment,
      nameFilterProduct,
      selectedCategoryChildren,
      nameFilter
    );
    getAllProduct();
    getAllEstablishment();
    getAllCategories();
    getAllCategoriesChildren();
  }, []);

  useEffect(() => {
    getReservesForChart();
  }, [establishment]);

  const getEstablishment = async () => {
    let response = await api.get(`/establishment/${props.match.params.id}`);
    setEstablishment(response.data.establishment);
  };

  const getComments = async (page, limit) => {
    let response = await api.get(`/comment/${props.match.params.id}?paginate=true&page=${page}&limit=${limit}`);
    setComments(response.data.docs);
  };

  const getALLComments = async () => {
    let response = await api.get(`/comment/${props.match.params.id}`);
    setTotalComments(response.data.length);
  };

  const getClientReservations = async (page, limit, user, status, name, product) => {
    let response = await api.get(
      `/establishmentReservations?paginate=true&establishment=${props.match.params.id}&limit=${limit}&page=${page}&user=${user}&status=${status}&name=${name}&product=${product}`
    );
    setClientReservation(response.data.docs);
  };

  // Pagination
  const setLimitList = (value) => {
    setQtLimitItem(value);
    getProduct(
      pageItemsList,
      value,
      selectedProduct,
      selectedEstablishment,
      nameFilterProduct,
      selectedCategoryChildren,
      nameFilter
    );
  };

  const changePage = (event) => {
    //
    setPageItemsListProduct(parseInt(event.target.id));
    getProduct(
      event.target.id,
      qtLimitItem,
      selectedProduct,
      selectedEstablishment,
      nameFilterProduct,
      selectedCategoryChildren,
      nameFilter
    );
  };

  const prevButton = () => {
    if (pageItemsList !== 1) {
      setPageItemsList(pageItemsList - 1);
      getProduct(
        pageItemsList - 1,
        qtLimitItem,
        selectedProduct,
        selectedEstablishment,
        nameFilterProduct,
        selectedCategoryChildren,
        nameFilter
      );
    }
  };

  const nextButton = () => {
    let qtPages = Math.ceil(totalItems / qtLimitItem);
    if (pageItemsList.toString() !== qtPages.toString()) {
      setPageItemsList(pageItemsList + 1);
      getProduct(
        pageItemsList + 1,
        qtLimitItem,
        selectedProduct,
        selectedEstablishment,
        nameFilterProduct,
        selectedCategoryChildren,
        nameFilter
      );
    }
  };
  const getAllClientReservations = async (idEstablishment) => {
    let response = await getClientReservationsAllByEstablishment(idEstablishment);
    setTotalClientReservation(response.total);
  };
  const setLimitListClient = (value) => {
    setQtLimitItemClient(value);
    setPageItemsList(1);
    getClientReservations(1, value, selectedClient, selectedStatus, nameFilterClient, selectedProduct);
  };
  const changePageClient = (event) => {
    setPageItemsList(parseInt(event.target.id));
    getClientReservations(
      event.target.id,
      qtLimitItemClient,
      selectedClient,
      selectedStatus,
      nameFilterClient,
      selectedProduct
    );
  };
  const prevButtonClient = () => {
    if (pageItemsList !== 1) {
      setPageItemsList(pageItemsList - 1);
      getClientReservations(
        pageItemsList - 1,
        qtLimitItemClient,
        selectedClient,
        selectedStatus,
        nameFilterClient,
        selectedProduct
      );
    }
  };
  const nextButtonClient = () => {
    let qtPages = Math.ceil(totalClientReservation / qtLimitItemClient);
    if (pageItemsList.toString() !== qtPages.toString()) {
      setPageItemsList(pageItemsList + 1);
      getClientReservations(
        pageItemsList + 1,
        qtLimitItemClient,
        selectedClient,
        selectedStatus,
        nameFilterClient,
        selectedProduct
      );
    }
  };

  const setLimitListComments = (value) => {
    setQtLimitItemComments(value);
    setPageComment(1);
    getComments(1, value);
  };
  const changePageComments = (event) => {
    setPageComment(parseInt(event.target.id));
    getComments(event.target.id, qtLimitItemComments);
  };
  const prevButtonComments = () => {
    if (pageComment !== 1) {
      setPageComment(pageComment - 1);
      getComments(pageComment - 1, qtLimitItemComments);
    }
  };
  const nextButtonComments = () => {
    let qtPages = Math.ceil(totalComments / qtLimitItemComments);
    if (pageComment.toString() !== qtPages.toString()) {
      setPageComment(pageComment + 1);
      getComments(pageComment + 1, qtLimitItemComments);
    }
  };

  // Filter
  const getAllProduct = async () => {
    let res = await getProductAll();
    setProductsAll(res.list);
  };

  const getAllEstablishment = async () => {
    let res = await AllEstablishment();
    setEstablishmentAll(res.list);
  };

  const getAllCategories = async () => {
    let res = await getCategories();
    setCategoryAll(res);
  };

  const getAllCategoriesChildren = async () => {
    let res = await getCategoriesChildren();
    setCategoryChildrenAll(res);
  };

  /*const handleSelectProduct = (value) => {
        setSelectedProduct(value);
        getProduct(pageItemsList, qtLimitItem, value, selectedEstablishment,selectedCategoryChildren, nameFilter);
    }*/

  const handleSelectEstablishment = (value) => {
    setSelectedEstablishment(value);
    getProduct(pageItemsList, qtLimitItem, selectedProduct, value, selectedCategoryChildren, nameFilter);
  };

  const handleSelectCategoryChildren = (value) => {
    setSelectedCategoryChildren(value);
    getProduct(pageItemsList, qtLimitItem, selectedProduct, selectedEstablishment, value, nameFilter);
  };

  const handleInputFilter = (value) => {
    setNameFilter(value);
    getProduct(pageItemsList, qtLimitItem, selectedProduct, selectedEstablishment, selectedCategoryChildren, value);
  };
  const getClient = async () => {
    let response = await getClientAll();
    setAllClient(response.list);
  };
  const getProducts = async () => {
    let response = await getProductAll();
    setAllProduct(response.list);
  };

  const handleSelectClient = (value) => {
    setSelectedClient(value);
    getClientReservations(pageItemsList, qtLimitItemClient, value, selectedStatus, nameFilterClient, selectedProduct);
  };
  const handleSelectProduct = (value) => {
    setSelectedProduct(value);
    getClientReservations(pageItemsList, qtLimitItemClient, selectedClient, selectedStatus, nameFilterClient, value);
  };
  const handleSelectStatus = (value) => {
    setSelectedStatus(value);
    getClientReservations(pageItemsList, qtLimitItemClient, selectedClient, value, nameFilterClient, selectedProduct);
  };
  const handleInputNameClient = (value) => {
    setNameFilterClient(value);
    getClientReservations(pageItemsList, qtLimitItemClient, selectedClient, selectedStatus, value, selectedProduct);
  };

  const handleSearchProduct = (value) => {
    setNameFilterProduct(value);
    getProduct(pageItemsList, qtLimitItem, selectedProduct, selectedEstablishment, selectedCategoryChildren, value);
  };

  const getReservesForChart = async () => {
    if (!establishment._id) return;
    const response = await api
      // TODO: Fix when client reservation group implemented
      .get(`/clientGroupReservation/${establishment._id}`);

    setPendentesChart(() => response.data.data?.reduce((acc, item) => item[1].pendentes + acc, 0));
    setReservasChart(() => response.data.data?.reduce((acc, item) => item[1].reservas + acc, 0));
    setCanceladasChart(() => response.data.data?.reduce((acc, item) => item[1].canceladas + acc, 0));
    setVendasChart(() => response.data.data?.reduce((acc, item) => item[1].vendas + acc, 0));
  };

  // Change status
  const handleStatus = async (item) => {
    if (item.status === "disabled") {
      item.status = "active";
    } else {
      item.status = "disabled";
    }
    await api.patch(`/establishment-update-status/${item._id}/?status=${item.status}`);
    getEstablishment();
  };

  useEffect(() => {
    RatingStars();
  }, [establishment]);

  const RatingStars = () => {
    let options = {
      count: 5,
      value: establishment?.rate,
      edit: true,
      isHalf: false,
      emptyIcon: <img alt="" width={24} height={24} className={"m-1"} src={outlineStar} />,
      filledIcon: <img alt="" width={24} height={24} className={"m-1"} src={filledStar} />,
    };
    console.log(loadingEstablishment);
    return setRatingStars(() => (
      <span className="d-flex justify-content-center align-items-center">
        {loadingEstablishment ? <></> : <ReactStars {...options} />}
        <span className="text-cl-black ff-univanova-regular fz-34 mt-1 ms-3">{establishment?.rate}</span>
      </span>
    ));
  };

  return (
    <>
      <Layout defaultMenu={1} title={establishment.storeName} link={""}>
        <div className="single-store container-fluid px-lg-0 pt-1 pb-5">
          <Cell className="mb-3">
            <CellItemWithImage
              image={
                establishment.establishmentPhoto?.length > 0
                  ? establishment.establishmentPhoto[0]?.url
                  : userDefaultImage
              }
              size={12}
              sizeLg={3}
              title={establishment.storeName}
              value={`E-mail: ${establishment.email}`}
            />
            <CellItem
              size={2}
              sizeLg={1}
              title="Segmento"
              value={establishment.category !== undefined ? establishment.category.name : ""}
            />
            <CellItem size={0} sizeLg={2} className={""} title="Tipo de plano" value="Ouro" />
            <CellItem size={3} sizeLg={2} title="Ingressou em" value={formatDate(establishment.createdAt)} />
            <CellItem
              size={1}
              sizeLg={1}
              title="Status"
              value={establishment.status === "disabled" ? "Inativo" : "Ativo"}
            />
            <CellItemLink size={3} sizeLg={2} title="Faturas" value="Ver faturas" />
            <CellItemSwitch
              size={12}
              sizeLg={1}
              onClick={() => handleStatus(establishment)}
              value={establishment.status === "disabled" ? false : true}
            />
          </Cell>
          <div className="row m-0 mt-4">
            <div className="col-12 col-lg-6 ps-0">
              {!vendasChart && !pendentesChart && !canceladasChart ? (
                <>
                  <div
                    className=" h-100 border rounded-3 overflow-hidden d-flex align-items-center justify-content-center"
                    style={{ maxHeight: "396px", maxWidth: "518" }}
                  >
                    <EmptyContentLittle description={"Não existem reservas"} />
                  </div>
                </>
              ) : (
                <DonutChart title="Reservas totais" info={[vendasChart, pendentesChart, canceladasChart]}></DonutChart>
              )}
            </div>
            <div className="col-12 col-lg-6 pe-0 mt-3 mt-lg-0" style={{ borderRadius: "25px" }}>
              <Carrossel
                images={establishment.establishmentPhoto?.length > 0 ? establishment.establishmentPhoto : false}
              ></Carrossel>
            </div>
            <div className="col-12 mt-5">
              <WidgetTitle title={"Últimas reservas"} />
            </div>
            <div className="col-12">
              <div className="d-flex flex-column flex-lg-row">
                <SearchInput value={nameFilterClient} onChange={handleInputNameClient} />
              </div>
              <div className="d-flex flex-column flex-lg-row pb-4 mt-3">
                <List
                  section={"reservas"}
                  onChange={(e) => setLimitListClient(e.target.value)}
                  limit={qtLimitItemClient}
                  totalItem={totalClientReservation}
                  prevButton={() => prevButtonClient()}
                  nextButton={() => nextButtonClient()}
                  page={pageItemsList}
                  changePage={(e) => changePageClient(e)}
                >
                  <ListHeader>
                    <ListHeaderItem sizeLg={2} title={"Usuário"}>
                      <ListHeaderItemDropdown>
                        <li
                          className="dropdown-header d-flex justify-content-end pt-0 pb-1 px-2"
                          style={{ borderBottom: "1px solid #D9D9D9" }}
                        >
                          <div className="input-group input-search">
                            <input
                              value={filterDropdownName}
                              onChange={(e) => setFilterDropdownName(e.target.value)}
                              type="text"
                              style={{ width: "173px" }}
                              className="input-dropdown form-control fz-14 border-0 box-shadow-none text-cl-auroMetal ff-roboto px-1 pb-0"
                              placeholder={"Procure por estabelecimento"}
                            />
                            <span className="input-group-text bg-white border-0">
                              <i className="bi bi-search " style={{ color: "#000000" }}></i>
                            </span>
                          </div>
                        </li>
                        <div className="filter-items" style={{ maxHeight: "238px" }}>
                          <div key={"all"} onClick={() => handleSelectClient("")} className="dropdown-item">
                            <span>Todos</span>
                          </div>
                          {clientReservation
                            .filter(
                              (element) =>
                                filterDropdownName === "" ||
                                String(element.user.name).toLowerCase().includes(filterDropdownName.toLocaleLowerCase())
                            )
                            .map((item, index) => (
                              <div
                                key={index}
                                onClick={() => handleSelectClient(item?.user?._id)}
                                className="dropdown-item"
                              >
                                <span>{item?.user?.name}</span>
                              </div>
                            ))}
                        </div>
                      </ListHeaderItemDropdown>
                    </ListHeaderItem>
                    <ListHeaderItem sizeLg={2} title={"Produto"}>
                      <ListHeaderItemDropdown>
                        <li
                          className="dropdown-header d-flex justify-content-end pt-0 pb-1 px-2"
                          style={{ borderBottom: "1px solid #D9D9D9" }}
                        >
                          <div className="input-group input-search">
                            <input
                              value={filterDropdownProductName}
                              onChange={(e) => setFilterDropdownProductName(e.target.value)}
                              type="text"
                              style={{ width: "173px" }}
                              className="input-dropdown form-control fz-14 border-0 box-shadow-none text-cl-auroMetal ff-roboto px-1 pb-0"
                              placeholder={"Procure por estabelecimento"}
                            />
                            <span className="input-group-text bg-white border-0">
                              <i className="bi bi-search " style={{ color: "#000000" }}></i>
                            </span>
                          </div>
                        </li>
                        <div className="filter-items" style={{ maxHeight: "238px" }}>
                          <div key={"allProduct"} onClick={() => handleSelectProduct("")} className="dropdown-item">
                            <span>Todos</span>
                          </div>
                          {products
                            .filter(
                              (element) =>
                                filterDropdownProductName === "" ||
                                String(element.name)
                                  .toLowerCase()
                                  .includes(filterDropdownProductName.toLocaleLowerCase())
                            )
                            .map((item, index) => (
                              <div key={index} onClick={() => handleSelectProduct(item._id)} className="dropdown-item">
                                <span>{item.name}</span>
                              </div>
                            ))}
                        </div>
                      </ListHeaderItemDropdown>
                    </ListHeaderItem>
                    <ListHeaderItem sizeLg={2} title={"Data"} />
                    <ListHeaderItem sizeLg={2} title={"Hora"} />
                    <ListHeaderItem sizeLg={2} title={"Valor"} />
                    <ListHeaderItem sizeLg={2} title={"Status"}>
                      <ListHeaderItemDropdown>
                        <div className="filter-items" style={{ maxHeight: "238px" }}>
                          {[
                            { name: "Todos", value: "" },
                            { name: "Confirmada", value: "Confirmada" },
                            { name: "Pendente", value: "Pendente" },
                            { name: "Cancelada", value: "Cancelada" },
                          ].map((item, index) => (
                            <div key={index} onClick={() => handleSelectStatus(item.value)} className="dropdown-item">
                              <span>{item.name}</span>
                            </div>
                          ))}
                        </div>
                      </ListHeaderItemDropdown>
                    </ListHeaderItem>
                  </ListHeader>
                  <ListBody>
                    {clientReservation.length ? (
                      <>
                        {clientReservation.map((item, index) => {
                          return (
                            <ListBodyCell key={index} className={`${index % 2 !== 0 ? "bg-cl-cultured" : ""}`}>
                              <ListBodyItem
                                sizeLg={2}
                                description={"User"}
                                title={(item.user !== undefined) & (item.user !== null) ? item.user.name : ""}
                              />
                              <ListBodyItem
                                sizeLg={2}
                                description={"Product"}
                                title={
                                  item?.products[0]?.product?.name !== "" ? item?.products[0]?.product?.name : "Nulo"
                                }
                              />
                              <ListBodyItem sizeLg={2} description="Data" title={formatDate(item.date)} />
                              <ListBodyItem sizeLg={2} description="Hora" title={item.time} />
                              <ListBodyItem
                                sizeLg={2}
                                description="Valor"
                                title={parseFloat(item.totalPrice).toFixed(2)}
                              />
                              <ListBodyItemStatus
                                sizeLg={2}
                                className={
                                  item.status === "Confirmada"
                                    ? "bg-cl-aero-blue border-forest-green text-cl-forest-green"
                                    : item.status === "Pendente"
                                    ? "border-princeton-orange bg-cl-anitque-white text-cl-princeton-orange"
                                    : item.status === "Cancelada"
                                    ? "border-venetian-red bg-cl-pale-pink text-cl-venetian-red"
                                    : "border-auro-metal bg-cl-bright-gray text-cl-dark-silver"
                                }
                                description="Status"
                                title={item.status}
                              />
                            </ListBodyCell>
                          );
                        })}
                      </>
                    ) : (
                      <EmptyListContent text={"Não existem reservas."} />
                    )}
                  </ListBody>
                </List>
              </div>
            </div>
            <div className="col-12 mt-1">
              <WidgetTitle title={"Produtos"} />
            </div>
            <div className="col-12">
              <div className="d-flex flex-column flex-lg-row">
                <SearchInput value={nameFilterProduct} onChange={handleSearchProduct} />
              </div>
              <div className="d-flex flex-column flex-lg-row pb-4 mt-3">
                <List
                  section={"produtos"}
                  onChange={(e) => setLimitList(e.target.value)}
                  limit={qtLimitItem}
                  totalItem={totalItems}
                  page={pageItemsListProduct}
                  prevButton={() => prevButton()}
                  nextButton={() => nextButton()}
                  changePage={(e) => changePage(e)}
                >
                  <ListHeader>
                    <ListHeaderItem sizeLg={2} title={""} />
                    <ListHeaderItem sizeLg={3} title={"Nome"}>
                      <ListHeaderItemDropdown>
                        <li
                          className="dropdown-header d-flex justify-content-end pt-0 pb-1 px-2"
                          style={{ borderBottom: "1px solid #D9D9D9" }}
                        >
                          <div className="input-group input-search">
                            <input
                              type="text"
                              style={{ width: "173px" }}
                              className="input-dropdown form-control fz-14 border-0 box-shadow-none text-cl-auroMetal ff-roboto px-1 pb-0"
                              placeholder={"Procure por estabelecimento"}
                            />
                            <span className="input-group-text bg-white border-0">
                              <i className="bi bi-search " style={{ color: "#000000" }}></i>
                            </span>
                          </div>
                        </li>
                        <div className="filter-items" style={{ maxHeight: "238px" }}>
                          <div className="dropdown-item">
                            <span>Todos</span>
                          </div>
                          {[...new Set(products.map((prod) => prod.name))].map((item) => (
                            <div className="dropdown-item">
                              <span>{item}</span>
                            </div>
                          ))}
                        </div>
                      </ListHeaderItemDropdown>
                    </ListHeaderItem>
                    <ListHeaderItem sizeLg={3} title={"Descrição"}>
                      <ListHeaderItemDropdown>
                        <div className="filter-items" style={{ maxHeight: "238px" }}>
                          <div className="dropdown-item">
                            <span>{"Todos"}</span>
                          </div>
                          {[...new Set(products.map((prod) => prod.description))].map((item) => (
                            <div className="dropdown-item">
                              <span>{item}</span>
                            </div>
                          ))}
                        </div>
                      </ListHeaderItemDropdown>
                    </ListHeaderItem>
                    <ListHeaderItem sizeLg={2} title={"Categoria"}>
                      <ListHeaderItemDropdown>
                        <div className="filter-items" style={{ maxHeight: "238px" }}>
                          <div className="dropdown-item">
                            <span>{"Todos"}</span>
                          </div>
                          {[...new Set(products.map((prod) => prod.category.name))].map((item) => (
                            <div className="dropdown-item">
                              <span>{item}</span>
                            </div>
                          ))}
                        </div>
                      </ListHeaderItemDropdown>
                    </ListHeaderItem>
                    {/* <ListHeaderItem sizeLg={3} title={"Reservas concluídas"}>
                      <ListHeaderItemDropdown>
                        <div className="filter-items" style={{ maxHeight: "238px" }}>
                          {[
                            { name: "Todos" },
                            { name: "Food" },
                            { name: "Moda" },
                            { name: "Pet" },
                            { name: "Beleza" },
                            { name: "Farmácia" },
                          ].map((item) => (
                            <div className="dropdown-item">
                              <span>{item.name}</span>
                            </div>
                          ))}
                        </div>
                      </ListHeaderItemDropdown>
                    </ListHeaderItem> */}
                  </ListHeader>
                  <ListBody>
                    {products.length ? (
                      <>
                        {products?.map((item, index) => (
                          <ListBodyCell key={index} className={`${index % 2 !== 0 ? "bg-cl-cultured" : ""}`}>
                            <ListBodyItemImage sizeLg={2} description={""} title={item?.productPhoto} />
                            <ListBodyItem sizeLg={3} description={"Nome"} title={item?.name} />
                            <ListBodyItem
                              sizeLg={3}
                              textColor={"text-cl-auroMetal"}
                              description={"Descrição"}
                              title={item?.description}
                            />
                            <ListBodyItem sizeLg={2} description="Categoria" title={item?.category?.name} />
                            {/* <ListBodyItem
                              sizeLg={3}
                              textColor={"text-cl-forest-green"}
                              description="Reservas Concluídas"
                              title={item?.vendas}
                            /> */}
                          </ListBodyCell>
                        ))}
                      </>
                    ) : (
                      <EmptyListContent text={"Não existem produtos."} />
                    )}
                  </ListBody>
                </List>
              </div>
            </div>
            <div className="col-12 mt-1">
              <WidgetTitle title={"Avaliações"} />
            </div>
            <div className="col-12 pb-2 px-2 mt-2">
              <div
                className="row m-0 d-flex justify-content-center align-items-center bg-cl-cultured-2"
                style={{ borderRadius: "10px" }}
              >
                <span style={{ textAlign: "center" }} className="text-cl-black ff-univanova-600 fz-20 mt-4">
                  Avaliação total do estabelecimento
                  {ratingStars}
                </span>
              </div>
            </div>
            <div className="col-12 mt-4 mb-4">
              <WidgetTitle title={"Últimos comentários"} />
            </div>
            <div className="col-12 d-flex">
              {comments.length ? (
                <ListComments
                  onChange={(e) => setLimitListComments(e.target.value)}
                  limit={qtLimitItemComments}
                  totalItem={totalComments}
                  prevButton={() => prevButtonComments()}
                  nextButton={() => nextButtonComments()}
                  page={pageComment}
                  changePage={(e) => changePageComments(e)}
                >
                  <>
                    {comments.map((item) => (
                      <>
                        <ListCommentsItem
                          avatar={item?.user?.avatar}
                          time={formatDate(item?.createdAt)}
                          userName={item?.user?.name}
                          stars={item?.rate}
                          comment={item?.comment}
                        />
                      </>
                    ))}
                  </>
                </ListComments>
              ) : (
                <div className="border rounded-3 col-12">
                  <EmptyListContent text={"Não existem comentários."} />
                </div>
              )}
            </div>
            <div className="col-12 mt-5">
              <WidgetTitle title={"Contato"} />
            </div>
            <div className="col-12">
              <div className="row m-0">
                <div className="col-lg-5 d-flex flex-column px-0">
                  <span className="text-cl-black ff-univanova-bold fz-14 my-2">Telefone</span>
                  <span className="text-cl-auroMetal ff-univanova-regular fz-14">
                    {establishment.phone === undefined || establishment.phone === null
                      ? "Não informado"
                      : establishment.phone}
                  </span>
                  <span className="text-cl-black ff-univanova-bold fz-14 my-2">Endereço</span>
                  <span className="text-cl-auroMetal ff-univanova-regular fz-14">
                    {establishment.address === undefined || establishment.address === null
                      ? "Não informado"
                      : establishment.address}
                  </span>
                  <span className="text-cl-black ff-univanova-bold fz-14 my-2">Email</span>
                  <span className="text-cl-auroMetal ff-univanova-regular fz-14">{establishment.email}</span>
                  <span className="text-cl-black ff-univanova-bold fz-14 mt-2">Redes sociais</span>
                  <div className="d-flex flex-row ">
                    {(establishment.facebook !== null) & (establishment.facebook !== undefined) ? (
                      <a href={establishment.facebook} target="_blank" className="" rel="noreferrer">
                        <img src={facebookIcon} width={24} height={24} alt="" />
                      </a>
                    ) : (
                      <></>
                    )}
                    {(establishment.instagram !== null) & (establishment.instagram !== undefined) ? (
                      <a href={establishment.instagram} target="_blank" className="" rel="noreferrer">
                        <img className="mx-1" src={instagranIcon} width={24} height={24} alt="" />
                      </a>
                    ) : (
                      <></>
                    )}
                    {(establishment.linkedin !== null) & (establishment.linkedin !== undefined) ? (
                      <a href={establishment.linkedin} target="_blank" className="" rel="noreferrer">
                        <img src={linkedinIcon} width={24} height={24} alt="" />
                      </a>
                    ) : (
                      <></>
                    )}
                    {(establishment.whatsapp !== null) & (establishment.whatsapp !== undefined) ? (
                      <a href={establishment.whatsapp} target="_blank" className="" rel="noreferrer">
                        <img className="mx-1" src={whatsappIcon} width={24} height={24} alt="" />
                      </a>
                    ) : (
                      <></>
                    )}
                    {(establishment.youtube !== null) & (establishment.youtube !== undefined) ? (
                      <a href={establishment.youtube} target="_blank" className="" rel="noreferrer">
                        <img src={youtubeIcon} width={24} height={24} alt="" />
                      </a>
                    ) : (
                      <></>
                    )}
                    {(establishment.facebook === null || establishment.facebook === undefined) &
                    (establishment.instagram === null || establishment.instagram === undefined) &
                    (establishment.linkedin === null || establishment.linkedin === undefined) &
                    (establishment.whatsapp === null || establishment.whatsapp === undefined) &
                    (establishment.youtube === null || establishment.youtube === undefined) ? (
                      <span className="text-cl-auroMetal ff-univanova-regular fz-14 mt-1">Não informado</span>
                    ) : (
                      <></>
                    )}
                  </div>
                  <span className="text-cl-black ff-univanova-bold fz-14 mt-3">CNPJ</span>
                  <span className="text-cl-auroMetal ff-univanova-regular fz-14 mt-1">
                    {establishment.cnpj !== undefined ? establishment.cnpj : "Não informado"}
                  </span>
                </div>
                <div className="col-lg-7 mt-2 mt-lg-0 d-flex flex-column justify-content-center">
                  {(establishment.localization !== null) & (establishment.localization !== undefined) ? (
                    establishment.localization.length > 0 ? (
                      <>
                        <div className="d-flex flex-column justify-content-center" style={{ height: "301px" }}>
                          <Maps
                            lat={establishment.localization[0].latitude}
                            lng={establishment.localization[0].longitude}
                          />
                        </div>
                        <a
                          href={`https://maps.google.com/?ll=${establishment.localization[0].latitude},${establishment.localization[0].longitude}`}
                          target="_blank"
                          style={{ width: "216px" }}
                          className="btn br-6 button-white-primary border-auro-metal fz-16 mx-auto px-4 mt-2"
                          rel="noreferrer"
                        >
                          Abrir no google maps
                        </a>
                      </>
                    ) : (
                      <></>
                    )
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}

export default SingleStore;
